import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

const Datenschutz = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const seoData = {
    title: currentLang === 'ru' ? 'Политика конфиденциальности - FotografX.de' : 'Datenschutzerklärung - FotografX.de',
    description: currentLang === 'ru' ? 'Политика конфиденциальности и защиты данных FotografX.de' : 'Datenschutzerklärung und Datenschutzrichtlinien von FotografX.de',
    keywords: currentLang === 'ru' ? 'конфиденциальность, защита данных, fotografx' : 'Datenschutz, Datenschutzerklärung, FotografX, DSGVO'
  };

  return (
    <div className="bg-black text-white">
      <SEO {...seoData} />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 
            className="text-4xl md:text-5xl font-bold mb-6 text-center"
            style={{ fontFamily: '"Times New Roman", serif' }}
          >
            {currentLang === 'ru' ? 'Политика конфиденциальности' : 'Datenschutzerklärung'}
          </h1>
          <p className="text-xl text-gray-300 text-center max-w-2xl mx-auto">
            {currentLang === 'ru' 
              ? 'Информация о защите и обработке ваших персональных данных'
              : 'Informationen zum Schutz und zur Verarbeitung Ihrer personenbezogenen Daten'
            }
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-invert prose-lg max-w-none">
            {currentLang === 'ru' ? (
              // Russian Content
              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    1. Ответственный за обработку данных
                  </h2>
                  <p className="text-gray-300 leading-relaxed">
                    Ответственным за обработку персональных данных на этом веб-сайте является:<br />
                    FotografX.de<br />
                    Email: info@fotografx.de
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    2. Сбор и использование персональных данных
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Мы собираем и используем персональные данные только в той мере, в которой это необходимо 
                    для предоставления функционального веб-сайта, а также наших услуг и контента.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Сбор и использование персональных данных наших пользователей осуществляется регулярно 
                    только с согласия пользователя. Исключение составляют случаи, когда предварительное 
                    получение согласия невозможно по фактическим причинам, а обработка данных разрешена 
                    законом.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    3. Контактная форма и запросы по электронной почте
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    При обращении к нам через контактную форму или по электронной почте ваши данные 
                    сохраняются для обработки запроса и на случай дополнительных вопросов.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Эти данные не передаются без вашего согласия.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    4. Файлы cookie
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Этот веб-сайт использует файлы cookie. Файлы cookie - это текстовые файлы, которые 
                    сохраняются в веб-браузере или веб-браузером на компьютерной системе пользователя.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Мы различаем между:
                  </p>
                  <ul className="text-gray-300 space-y-2 mb-4">
                    <li>• <strong>Необходимые файлы cookie:</strong> Необходимы для основных функций веб-сайта</li>
                    <li>• <strong>Аналитические файлы cookie:</strong> Помогают нам понять, как посетители взаимодействуют с веб-сайтом</li>
                    <li>• <strong>Маркетинговые файлы cookie:</strong> Используются для показа релевантной рекламы</li>
                  </ul>
                  <p className="text-gray-300 leading-relaxed">
                    Вы можете настроить использование файлов cookie через баннер согласия на файлы cookie 
                    или изменить настройки в любое время через ссылку в футере.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    5. Логи сервера
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Поставщик страниц автоматически собирает и сохраняет информацию в так называемых 
                    логах сервера, которые ваш браузер автоматически передает нам. Это:
                  </p>
                  <ul className="text-gray-300 space-y-2 mb-4">
                    <li>• Тип и версия браузера</li>
                    <li>• Используемая операционная система</li>
                    <li>• URL реферера</li>
                    <li>• Имя хоста обращающегося компьютера</li>
                    <li>• Время запроса сервера</li>
                    <li>• IP-адрес</li>
                  </ul>
                  <p className="text-gray-300 leading-relaxed">
                    Эти данные не объединяются с другими источниками данных. Данные удаляются через 
                    7 дней после регистрации.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    6. Ваши права
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">У вас есть следующие права:</p>
                  <ul className="text-gray-300 space-y-2 mb-4">
                    <li>• <strong>Право на информацию:</strong> Информация о ваших сохраненных данных</li>
                    <li>• <strong>Право на исправление:</strong> Исправление неверных данных</li>
                    <li>• <strong>Право на удаление:</strong> Удаление ваших данных</li>
                    <li>• <strong>Право на ограничение:</strong> Ограничение обработки ваших данных</li>
                    <li>• <strong>Право на переносимость данных:</strong> Получение ваших данных в машиночитаемом формате</li>
                    <li>• <strong>Право на возражение:</strong> Возражение против обработки ваших данных</li>
                  </ul>
                  <p className="text-gray-300 leading-relaxed">
                    Для осуществления ваших прав свяжитесь с нами по адресу: info@fotografx.de
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    7. Безопасность данных
                  </h2>
                  <p className="text-gray-300 leading-relaxed">
                    Мы используем подходящие технические и организационные меры безопасности для защиты 
                    ваших данных от случайной или преднамеренной манипуляции, потери, уничтожения или 
                    доступа неавторизованных лиц.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    8. Изменения в политике конфиденциальности
                  </h2>
                  <p className="text-gray-300 leading-relaxed">
                    Мы оставляем за собой право изменить эту политику конфиденциальности для соответствия 
                    текущим правовым требованиям или для реализации изменений наших услуг в политике 
                    конфиденциальности.
                  </p>
                </div>

                <div className="border-t border-gray-700 pt-8">
                  <p className="text-gray-400 text-sm">
                    Действует с: Январь 2025<br />
                    FotografX.de<br />
                    Статус: Январь 2025
                  </p>
                </div>
              </div>
            ) : (
              // German Content
              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    1. Verantwortlicher
                  </h2>
                  <p className="text-gray-300 leading-relaxed">
                    Verantwortlicher für die Datenverarbeitung auf dieser Website ist:<br />
                    FotografX.de<br />
                    E-Mail: info@fotografx.de
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    2. Erhebung und Verwendung personenbezogener Daten
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Wir erheben und verwenden personenbezogene Daten nur, soweit dies zur Bereitstellung 
                    einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Die Erhebung und Verwendung personenbezogener Daten unserer Nutzer erfolgt regelmäßig 
                    nur nach Einwilligung des Nutzers. Eine Ausnahme gilt in solchen Fällen, in denen eine 
                    vorherige Einholung einer Einwilligung aus tatsächlichen Gründen nicht möglich ist und 
                    die Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    3. Kontaktformular und E-Mail-Kontakt
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Bei der Kontaktaufnahme mit uns (zum Beispiel über das Kontaktformular oder per E-Mail) 
                    werden Ihre Angaben zur Bearbeitung der Anfrage sowie für den Fall von Anschlussfragen 
                    bei uns gespeichert.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    4. Cookies
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Diese Website verwendet Cookies. Cookies sind Textdateien, die im Webbrowser bzw. 
                    vom Webbrowser auf dem Computersystem des Nutzers gespeichert werden.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Wir unterscheiden zwischen:
                  </p>
                  <ul className="text-gray-300 space-y-2 mb-4">
                    <li>• <strong>Notwendige Cookies:</strong> Erforderlich für grundlegende Website-Funktionen</li>
                    <li>• <strong>Analyse-Cookies:</strong> Helfen uns zu verstehen, wie Besucher mit der Website interagieren</li>
                    <li>• <strong>Marketing-Cookies:</strong> Werden verwendet, um relevante Werbung zu zeigen</li>
                  </ul>
                  <p className="text-gray-300 leading-relaxed">
                    Sie können die Verwendung von Cookies über das Cookie-Consent-Banner konfigurieren 
                    oder die Einstellungen jederzeit über den Link im Footer ändern.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    5. Server-Log-Dateien
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten 
                    Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
                  </p>
                  <ul className="text-gray-300 space-y-2 mb-4">
                    <li>• Browsertyp und Browserversion</li>
                    <li>• verwendetes Betriebssystem</li>
                    <li>• Referrer URL</li>
                    <li>• Hostname des zugreifenden Rechners</li>
                    <li>• Uhrzeit der Serveranfrage</li>
                    <li>• IP-Adresse</li>
                  </ul>
                  <p className="text-gray-300 leading-relaxed">
                    Diese Daten werden nicht mit anderen Datenquellen zusammengeführt. Die Daten werden 
                    nach 7 Tagen nach der Aufzeichnung gelöscht.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    6. Ihre Rechte
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">Sie haben folgende Rechte:</p>
                  <ul className="text-gray-300 space-y-2 mb-4">
                    <li>• <strong>Recht auf Auskunft:</strong> Informationen über Ihre gespeicherten Daten</li>
                    <li>• <strong>Recht auf Berichtigung:</strong> Korrektur unrichtiger Daten</li>
                    <li>• <strong>Recht auf Löschung:</strong> Löschung Ihrer Daten</li>
                    <li>• <strong>Recht auf Einschränkung:</strong> Einschränkung der Verarbeitung Ihrer Daten</li>
                    <li>• <strong>Recht auf Datenübertragbarkeit:</strong> Erhalt Ihrer Daten in maschinenlesbarem Format</li>
                    <li>• <strong>Widerspruchsrecht:</strong> Widerspruch gegen die Verarbeitung Ihrer Daten</li>
                  </ul>
                  <p className="text-gray-300 leading-relaxed">
                    Zur Geltendmachung Ihrer Rechte wenden Sie sich bitte an: info@fotografx.de
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    7. Datensicherheit
                  </h2>
                  <p className="text-gray-300 leading-relaxed">
                    Wir verwenden geeignete technische und organisatorische Sicherheitsmaßnahmen, um Ihre 
                    Daten gegen zufällige oder vorsätzliche Manipulationen, teilweisen oder vollständigen 
                    Verlust, Zerstörung oder gegen den unbefugten Zugriff Dritter zu schützen.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    8. Änderung der Datenschutzerklärung
                  </h2>
                  <p className="text-gray-300 leading-relaxed">
                    Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen 
                    rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der 
                    Datenschutzerklärung umzusetzen.
                  </p>
                </div>

                <div className="border-t border-gray-700 pt-8">
                  <p className="text-gray-400 text-sm">
                    Gültig ab: Januar 2025<br />
                    FotografX.de<br />
                    Stand: Januar 2025
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Datenschutz;